import React from 'react'

import { colors, sizes } from '~/assets/styles/variables'

import { P2Bold } from '~/components/atoms/Paragraph'

import { P2Subtitle, SubtitleWrapper } from './RadioButtonContent.styles'

const { darkGray } = colors
const { size0, size4 } = sizes

interface RadioButtonContentInterface {
  title: string
  subtitleAux: string
}

const RadioButtonContent = ({ title, subtitleAux }: RadioButtonContentInterface) => (
  <>
    <P2Bold marginBottom={size4}>
      {title.toUpperCase()}
    </P2Bold>
    <SubtitleWrapper>
      <P2Subtitle color={darkGray} marginBottom={size0}>
        {subtitleAux}
        {' '}
        {title}
        !
      </P2Subtitle>
    </SubtitleWrapper>
  </>
)

export default RadioButtonContent
